export const PAGETYPE_TO_TOUCHPOINT = {
  ProductPage: 'PDP',
  HeroPDPPage: 'HERO_PDP',
} as const;
